export * from './camera-table-details.component';
